<template>
	<div @click="onClick" role="button" class="skipped-btn-container">
		<AppTextTooltip :tooltipText="tooltipText">
			<SIcon name="skipped-block" />
		</AppTextTooltip>
	</div>
</template>

<script>
export default {
	name: 'SkippedContextualNodeBtn',
	props: { placement: { type: Object } },
	computed: {
		tooltipText() {
			return `Get contextual ${this.placement.item_name} skipped.</br>Click to enable.`;
		},
	},
	methods: {
		onClick() {
			this.$emit('onClick');
		},
	},
};
</script>

<style scoped lang="scss">
.skipped-btn-container {
	height: 18px;
	width: 18px;
	border: 1px #d6ddeb solid;
	border-radius: 2px;
}
</style>
